import { HttpClient } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { MatSelectModule } from '@angular/material/select';
import { GkComponentsModule, GkMapModule } from '@gk/gk-modules';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { SharedModule } from '../../shared/shared.module';
import { createTranslateLoader } from '../address-number-request-portal/address-number-request-portal.module';
import { AdjacentPropertyNeedEnterDecisionRoutingModule } from './adjacent-property-need-enter-decision-routing.module';
import { APNEDNewRequestComponent } from './new-request/new-request.component';
import { APNEDNewRequestFormService } from './services/new-request-form/new-request-form.service';

@NgModule({
  declarations: [APNEDNewRequestComponent],
  imports: [
    SharedModule,
    TranslateModule.forChild({
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [HttpClient],
      },
    }),
    GkMapModule,
    GkComponentsModule,
    AdjacentPropertyNeedEnterDecisionRoutingModule,
    MatSelectModule,
  ],
  providers: [APNEDNewRequestFormService],
})
export class AdjacentPropertyNeedEnterDecisionModule {}
